import React from "react";
import {
  injectStripe,
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  PostalCodeElement
} from "react-stripe-elements";
import { Row } from "antd";
class _CardForm extends React.Component {
  createOptions = (fontSize, padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#9e2146"
        }
      }
    };
  };

  render() {
    return (
      <div style={{ justifyContent: "space-between", paddingRight: "50px" }}>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ marginTop: "15px" }}
        >
          <label>
            Votre numéro de carte bancaire
            <CardNumberElement {...this.createOptions(this.props.fontSize)} />
          </label>
        </Row>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ marginTop: "15px" }}
        >
          <label>
            Date d'expiration de votre carte
            <CardExpiryElement {...this.createOptions(this.props.fontSize)} />
          </label>
        </Row>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ marginTop: "15px" }}
        >
          <label>
            Numéro CVC
            <CardCVCElement {...this.createOptions(this.props.fontSize)} />
          </label>
        </Row>
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ marginTop: "15px" }}
        >
          <label>
            Votre code postal
            <PostalCodeElement {...this.createOptions(this.props.fontSize)} />
          </label>
        </Row>
      </div>
    );
  }
}

const CardForm = injectStripe(_CardForm);

export default CardForm;
